// extracted by mini-css-extract-plugin
export default {"column":"SignIn_column__nAwTz","formHeader":"SignIn_formHeader__ozhZn","authLinks":"SignIn_authLinks__hsBiM","logoLink":"SignIn_logoLink__UUFdB","appLogo":"SignIn_appLogo__0TP07"};